import type { EventKey } from "../../../event/server/supabase-event-service";

export const isScheduled = (event: EventKey | null): boolean =>
  !event || event.has_schedule_event || !event.calendar;
